import "./chunk866.js";
import * as s from "react";
import { DEBUG_BUILD as u } from "./chunk867.js";
import { captureReactException as k } from "./chunk863.js";
import { getClient as _, withScope as E } from "./chunk868.js";
import { showReportDialog as l } from "./chunk869.js";
import { logger as I } from "./chunk870.js";
const c = {
  componentStack: null,
  error: null,
  eventId: null
};
class p extends s.Component {
  constructor(t) {
    super(t), p.prototype.__init.call(this), this.state = c, this._openFallbackReportDialog = !0;
    const o = _();
    o && t.showDialog && (this._openFallbackReportDialog = !1, this._cleanupHook = o.on("afterSendEvent", (e) => {
      !e.type && this._lastEventId && e.event_id === this._lastEventId && l({ ...t.dialogOptions, eventId: this._lastEventId });
    }));
  }
  componentDidCatch(t, o) {
    const { componentStack: e } = o, n = e ?? void 0, { beforeCapture: r, onError: a, showDialog: d, dialogOptions: h } = this.props;
    E((f) => {
      r && r(f, t, n);
      const m = this.props.handled != null ? this.props.handled : !!this.props.fallback, i = k(t, o, { mechanism: { handled: m } });
      a && a(t, n, i), d && (this._lastEventId = i, this._openFallbackReportDialog && l({ ...h, eventId: i })), this.setState({ error: t, componentStack: e, eventId: i });
    });
  }
  componentDidMount() {
    const { onMount: t } = this.props;
    t && t();
  }
  componentWillUnmount() {
    const { error: t, componentStack: o, eventId: e } = this.state, { onUnmount: n } = this.props;
    n && n(t, o, e), this._cleanupHook && (this._cleanupHook(), this._cleanupHook = void 0);
  }
  __init() {
    this.resetErrorBoundary = () => {
      const { onReset: t } = this.props, { error: o, componentStack: e, eventId: n } = this.state;
      t && t(o, e, n), this.setState(c);
    };
  }
  render() {
    const { fallback: t, children: o } = this.props, e = this.state;
    if (e.error) {
      let n;
      return typeof t == "function" ? n = s.createElement(t, {
        error: e.error,
        componentStack: e.componentStack,
        resetError: this.resetErrorBoundary,
        eventId: e.eventId
      }) : n = t, s.isValidElement(n) ? n : (t && u && I.warn("fallback did not produce a valid ReactElement"), null);
    }
    return typeof o == "function" ? o() : o;
  }
}
export {
  p as ErrorBoundary
};
